export const LEARN_MORE_LINKS = {
  shopifySettings: {
    helpCenter:
      'https://helpcenter.prisync.com/hc/en-us/articles/360007508494-Shopify',
  },
  competitorSettings: {
    monitoringStyle:
      'https://helpcenter.prisync.com/hc/en-us/articles/5116429087772-How-to-set-up-channel-based-monitoring-Prisync-panel-integrated-with-Shopify',
  },
}

export const EMPTY_STATE_IMAGES = {
  overviewImage:
    'https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png',
  settingsImage:
    'https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png',
  subscriptionImage:
    'https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png',
}
